module.exports = __webpack_public_path__ + "assets/calender_old.998b6b53.svg";